<template>
  <div>
    <v-row no-gutters>
      <v-btn id="kpiCalculation" color="#c00000" class="white--text" :loading="loading && values == undefined"
        :disabled="values != undefined" @click="startCalculation">
        KPIs berechnen ({{ fiscalYearLabel }})
      </v-btn>
    </v-row>

    <v-row v-if="values != undefined">
      <v-col v-for="KPI in values" :key="KPI.title" md="6" lg="4" xl="3" class="pt-3 pb-0">
        <v-row no-gutters style="font-size: 13px !important;">
          <v-col cols="6">
            <div><b>{{ KPI.title }}</b>
              <v-tooltip v-if="KPI.description" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="pa-1" small>
                    mdi-information
                  </v-icon>
                </template>
                <span>{{ KPI.description }}</span>
              </v-tooltip>
            </div>
          </v-col>

          <v-col cols="6" class="custom-vertical-center">
            <div>{{ KPI.amount }} {{ KPI.unit }}</div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'EmployeeKPI',
  props: ['userId', 'client'],

  data() {
    return {
      loading: false,
      values: undefined
    }
  },

  computed: {
    displayedDate: function () {
      return this.$store.state.displayedMonth;
    },

    kpiYear: function () {
      return this.displayedDate.isoMonth() < 7 ? this.displayedDate.year() : this.displayedDate.year() + 1;
    },

    fiscalYearLabel: function () {
      const end = this.kpiYear % 100;
      const start = (this.kpiYear - 1) % 100;
      return `GJ ${String(start).padStart(2, '0')}/${String(end).padStart(2, '0')}`;
    }
  },

  methods: {
    async startCalculation() {
      this.loading = true;
      const KPIs = await this.client.calcUserKPIs(this.userId, this.kpiYear);
      this.loading = false;

      this.values = Object.values(KPIs);
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-vertical-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
